module.exports = __webpack_public_path__ + "img/el.d25c48ea.svg";